import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { DarkModeRounded, LightModeRounded } from "@mui/icons-material";
import logo from "../assets/logo.png";

export default function NavBar({
  mode,
  onToggleMode,
}: {
  mode: "light" | "dark";
  onToggleMode: () => void;
}) {
  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        bgcolor: (t) => alpha(t.palette.background.default, 0.8),
        backdropFilter: "saturate(180%) blur(12px)",
        WebkitBackdropFilter: "saturate(180%) blur(12px)",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          maxWidth: 1536,
          mx: "auto",
          height: 60,
          px: { xs: 2, sm: 3, md: 5 },
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <Box
            component="img"
            src={logo}
            alt="ProText"
            sx={{ height: 28, width: 28, borderRadius: "50%", display: "block", flexShrink: 0 }}
          />
          <Typography component="span" variant="h6" sx={{ color: "text.primary" }}>
            ProText
          </Typography>

          {/* The page's primary <h1> lives in the header so the tool gets the
              full page below it. Hidden on small screens to keep the bar tight;
              the brand above stays visible everywhere. */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 1.5, my: 1.25, display: { xs: "none", md: "block" } }}
          />
          <Typography
            component="h1"
            noWrap
            sx={{
              display: { xs: "none", md: "block" },
              fontSize: 13,
              fontWeight: 600,
              color: "text.secondary",
              minWidth: 0,
            }}
          >
            ProPresenter Lyrics &amp; Scripture Formatter
          </Typography>
        </Box>

        <Box sx={{ flex: 1 }} />

        <Tooltip title={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}>
          <IconButton
            onClick={onToggleMode}
            aria-label="Toggle dark mode"
            sx={{ color: "text.secondary" }}
          >
            {mode === "dark" ? (
              <LightModeRounded fontSize="small" />
            ) : (
              <DarkModeRounded fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}
